import React from 'react';
import styled from 'styled-components';
import { border3D } from '../../constants';
import image from './fast-forward.png';

const Image = styled.img`
${border3D}
border-color: red;
height: 4rem;
background: red;

padding-right: 0.5rem;
padding-left: 0.5rem;
margin-top: auto;
margin-bottom: 2rem;

    :hover {
      border-color: blue;
    }
`;

export default function NextButton(props) {
  const {
    onClick,
  } = props;

  return (

    <Image onClick={() => onClick()} src={image} alt="next" />


  );
}
